import { AsyncPipe, NgIf } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { ResolveDirective } from "@recursyve/nice-ui-kit.v2";
import { CitizenIntroductionComponent } from "./citizen-introduction.component";
import { CitizenIntroductionQuery } from "./store/citizen-introduction.query";
import { CitizenIntroductionService } from "./store/citizen-introduction.service";
import { CitizenIntroductionStore } from "./store/citizen-introduction.store";

@NgModule({
    declarations: [CitizenIntroductionComponent],
    imports: [AsyncPipe, MatButtonModule, MatIconModule, ResolveDirective, NgIf, TranslateModule],
    providers: [CitizenIntroductionQuery, CitizenIntroductionService, CitizenIntroductionStore],
    exports: [CitizenIntroductionComponent]
})
export class CitizenIntroductionModule {}
